<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-4">
      <search-form :fields="search" />
      <el-button @click="jumpBuyOffline" v-if="hasPermOrderBuyOffline"><i class="el-icon-goods" />线下销售</el-button>
      <!-- <el-button @click="jumpImportOffline"><i class="el-icon-upload2" />订单导入</el-button> -->
      <el-popconfirm
        confirm-button-text="确定"
        cancel-button-text="取消"
        icon="el-icon-info"
        icon-color="red"
        title="确认离线导出么？"
        @confirm="rsyncExport('all')"
      >
        <el-button slot="reference" v-if="hasPermOrderBuyAllExport"><i class="el-icon-download" />离线导出(所有)
        </el-button>
      </el-popconfirm>
      <el-popconfirm
        confirm-button-text="确定"
        cancel-button-text="取消"
        icon="el-icon-info"
        icon-color="red"
        title="确认离线导出么？"
        @confirm="rsyncExport('offline')"
      >
        <el-button slot="reference" v-if="hasPermOrderBuyExport"><i class="el-icon-download" />离线导出(线下)
        </el-button>
      </el-popconfirm>
      <button-link :to="`downloads`" v-if="hasPermsManageDownload"><i class="el-icon-download" />下载中心</button-link>
    </el-button-group>

    <el-row class="grid-content bg-el-row " v-for="item in orders" :key="item.id" v-loading="loading">
      <el-col :xl="24" :xs="24" :sm="24" :md="24" :lg="24">
        <div class="grid-content-col-title">
          <el-col :xl="8" :xs="24" :md="24" :lg="8" :sm="24">
            <div>订单编号：{{ item.order_id }}[{{ item.order_type_text }}]</div>
          </el-col>
          <el-col :xl="6" :xs="6" :md="6" :lg="5" :sm="6">
            <div>
              审核状态：
              <el-tag
                :type="item.audit_status === 2 ? 'danger' : item.audit_status === 1 ? 'success' : 'warning'"
                size="small"
                disable-transitions
              >
                {{ item.audit_status_text }}
              </el-tag>
            </div>
          </el-col>
          <el-col :xl="6" :xs="6" :md="6" :lg="4" :sm="6">
            <div>
              发货状态：
              <el-tag v-if="item.audit_status === 1" size="small" disable-transitions>
                {{ item.status_text }}
                <span type="success" v-if="item.pick_up_order">[自提]</span>
              </el-tag>
            </div>
          </el-col>
          <el-col :xl="3" :xs="8" :md="8" :lg="5" :sm="8">
            <div>
              <span><i class="el-icon-pie-chart" />：</span>{{ item.pay_time }}
            </div>
          </el-col>
          <el-col :xl="1" :xs="4" :md="4" :lg="2" :sm="4">
            <div class="action">
              <el-dropdown>
                <el-button size="small">操作</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-view" v-if="hasPermsEdit">
                    <router-link :to="'/order-offline/' + item.id + '/edit'">
                      <el-button type="text" size="small">查看详情</el-button>
                    </router-link>
                  </el-dropdown-item>

                  <el-dropdown-item icon="el-icon-printer" v-if="item.audit_status === 1 && hasPermsPrint" divided>
                    <router-link :to="'/order-offline/' + item.id + '/print'">
                      <el-button type="text" size="small">打印清单</el-button>
                    </router-link>
                  </el-dropdown-item>

                  <el-dropdown-item icon="el-icon-guide" v-if="item.audit_status === 1 && hasPermsPrint" divided>
                    <el-button type="text" size="small" @click="onPrinterOrderConfirm(item)">打印小票</el-button>
                  </el-dropdown-item>

                  <el-dropdown-item icon="el-icon-guide" v-if="item.audit_status === 1 && hasPermsRefuse" divided>
                    <el-button type="text" size="small" @click="onRefuseOrderConfirm(item)">退单</el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-col>
        </div>
      </el-col>
      <el-col :xl="24" :xs="24" :md="24" :lg="24" :sm="24">
        <div class="grid-content-col-body">
          <el-col :xl="8" :xs="24" :md="24" :lg="5" :sm="24">
            <div class="grid-body-left">
              <ul>
                <span>商品信息：</span>
                <li v-for="good in item.items" :key="good.id">
                  <!-- <img :src="good.thumbnail_pic"> -->
                  <!-- <span>{{ good.name }}*{{ good.price }}*{{ good.nums }}</span> -->
                  <el-image
                    style="width: 25px; height: 25px"
                    :src="good.thumbnail_pic"
                    :preview-src-list="[good.thumbnail_pic]"
                  >
                    <div slot="error" class="image-slot"><i class="el-icon-picture-outline" /></div>
                  </el-image>
                  <span v-if="isLogistics"> {{ good.name }}*{{ good.nums }} </span>
                  <span v-else> {{ good.name }}*{{ good.price }}*{{ good.nums }} </span>
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :xl="16" :xs="18" :md="18" :lg="17" :sm="18">
            <div class="grid-body-right">
              <el-col :xl="24" :xs="24" :md="24" :lg="24" :sm="24">
                <div class="grid-body-right-content grid-body-right-content-first">
                  <el-col :xl="6" :xs="24" :md="24" :lg="6" :sm="24" v-if="!isLogistics">
                    <div class="grid-right-top">金额：{{ item.final_amount }}</div>
                  </el-col>
                  <!-- <el-col :xl="12" :xs="24" :md="24" :lg="12" :sm="24">
                    <div class="grid-right-top" v-if="isLogistics">账户信息：{{ item.user.real_name }}</div>
                    <div class="grid-right-top" v-else>
                      账户信息：{{ item.user.real_name }}({{ item.user.level_name }}) {{ item.user.mobile }}
                    </div>
                  </el-col> -->
                  <el-col :xl="6" :xs="24" :md="24" :lg="6" :sm="24">
                    <div class="grid-right-top grid-right-top-last">
                      物流信息：{{ item.belong_delivery_user_name }}
                      <el-button v-if="hasPermsExpress" @click="expressOrderInfo(item)" size="mini" type="text">
                        查看物流
                      </el-button>
                    </div>
                  </el-col>
                </div>
              </el-col>
              <!-- <el-col :xl="24" :xs="24" :md="24" :lg="24" :sm="24">
                <div class="grid-body-right-content">发货信息：{{ item.ship_area }}</div>
              </el-col> -->
              <el-col :xl="24" :xs="24" :md="24" :lg="24" :sm="24">
                <div class="grid-body-right-content grid-body-right-content-last">
                  收货信息：{{ item.ship_name }}({{ item.ship_mobile }}){{ item.ship_addr }}
                </div>
              </el-col>
            </div>
          </el-col>
        </div>
      </el-col>
    </el-row>
    <div class="card-footer">
      <pagination :page="page" />
    </div>

    <el-drawer title="物流信息" :visible.sync="drawer">
      <el-card class="box-card">
        <el-tabs v-model="activeName">
          <el-tab-pane
            v-for="(express, index) in expressOrder.express_company_name_array"
            :key="index"
            :label="'包裹' + (index + 1)"
            :name="index+''"
          >
            <el-row :gutter="12" style="font-weight:500; font-size: 14px;margin-top: 10px; margin-bottom: 20px;">
              <el-col :span="12">
                <div class="text item">物流公司: {{ express || '' }}</div>
              </el-col>

              <el-col :span="12">
                <div class="text item">快递单号: {{ expressOrder.express_no_array[index] || '' }}</div>
              </el-col>
            </el-row>

            <el-row :gutter="12" style="height:650px;overflow-y:auto;overflow-x:hidden;">
              <el-col :span="24">
                <div v-if="expressList[index].status != 0">{{ expressList[index].msg }}</div>
                <el-timeline v-else>
                  <el-timeline-item
                    v-for="(timeList, index) in (expressList[index]['result']['list'] || [])"
                    :key="index"
                    :timestamp="timeList.time"
                  >
                    {{ timeList.status }}
                  </el-timeline-item>
                </el-timeline>
              </el-col>
            </el-row>

          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-drawer>

    <el-dialog title="导入线下订单" :visible.sync="updateImportDialog" width="400px" append-to-body>
      <el-upload
        class="upload-demo"
        ref="upload"
        action=""
        :limit="1"
        accept=".csv,.xlsx,.xls"
        :multiple="false"
        :on-remove="handleRemove"
        :on-change="fileChange"
        :before-upload="beforeUpload"
        :before-remove="beforeRemove"
        :http-request="uploadFile"
        :file-list="fileList"
        :auto-upload="false"
      >
        <!-- .xls格式：application/vnd.ms-excel .xlsx格式：application/vnd.openxmlformats-officedocument.spreadsheetml.sheet -->
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="onUpdateImport">上传到服务器
        </el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传xls/xlxs文件, 文件大小不超过10M
        </div>
      </el-upload>
    </el-dialog>
  </el-card>
</template>

<script>
import { exportOrder, expressOrder, getOrders, importOrder, printerOrder, refuseOrder } from '@/api/order-offline'
import { can, getFirstError } from '@/libs/utils'
import ButtonLink from '@c/ButtonLink'
// import LzForm from '@c/LzForm'
// import FormHelper from '@c/LzForm/FormHelper'
import Pagination from '@c/Pagination'
import SearchForm from '@c/SearchForm'

export default {
  name: 'Index',
  components: {
    SearchForm,
    Pagination,
    ButtonLink,
    // LzForm,
  },
  // mixins: [FormHelper],
  data() {
    return {
      search: [
        {
          field: 'order_id',
          label: '订单号',
        },
        {
          field: 'title',
          label: '订单名称',
        },
        {
          field: 'order_type',
          label: '订单类型',
          type: 'el-select',
          options: [
            { id: 0, name: '普单订单' },
            { id: 1, name: '报单订单' },
            { id: 2, name: '积分订单' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'audit_status',
          label: '审核状态',
          type: 'el-select',
          options: [
            { id: 0, name: '待审核' },
            { id: 1, name: '审核成功' },
            { id: 2, name: '拒绝' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'status',
          label: '发货状态',
          type: 'el-select',
          options: [
            { id: 0, name: '待发货' },
            { id: 1, name: '发货中' },
            { id: 2, name: '已完成' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'created_at',
          label: '获得时间',
          type: 'el-date-picker',
        },
        {
          field: 'express',
          label: '收件信息(手机、姓名)',
        },
      ],
      orders: [],
      page: null,
      query: {},
      loading: true,
      hasPermsEdit: false,
      hasPermsPrint: false,
      hasPermsRefuse: false,
      hasPermOrderBuyOffline: false,
      hasPermOrderBuyAllExport: false,
      hasPermsExpress: false,
      hasPermOrderBuyExport: false,
      hasPermsManageDownload: false,
      isLogistics: false,

      activeName: '0',

      drawer: false,
      expressList: [],
      expressOrder: [],

      formData: '',
      updateImportDialog: false, // 导入
      importForm: {},
      fileList: [],
      file: null,
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.query = newVal.query
        await this.loadOrders()
      },
      immediate: true,
    },
  },
  methods: {
    async loadOrders() {
      this.loading = true
      const {
        data: { data, meta, isLogistics },
      } = await getOrders(this.query)
      this.orders = data
      this.page = meta
      this.isLogistics = isLogistics
      this.loading = false
    },
    async onRefuseOrderConfirm(row) {
      this.$confirm('确认要退单操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async() => {
          const { data } = await refuseOrder(row.order_id, {})
          this.loadOrders()
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    async onPrinterOrderConfirm(row) {
      this.$confirm('确认要打印小票操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async() => {
          const { data } = await printerOrder(row.order_id, {})
          if (data.code == 200) {
            this.$message({
              type: 'success',
              message: '打印成功!',
            })
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
            })
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    async jumpBuyOffline() {
      this.$router.push('/order-offline/create')
    },
    async rsyncExport(option) {
      try {
        await exportOrder({ ...this.query, option })
        this.$message.success('离线下载中...')
      } catch (e) {
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
      }
    },

    /** 文件预上传格式限制 */
    beforeUpload(file) {
      // 文件类型
      const isType = file.type === 'application/vnd.ms-excel'
      const isTypeComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const fileType = isType || isTypeComputer
      if (!fileType) {
        this.$message.error('上传文件只能是xls/xlsx格式！')
      }

      // 文件大小限制为10M
      const fileLimit = file.size / 1024 / 1024 < 10
      if (!fileLimit) {
        this.$message.error('上传文件大小不超过10M！')
      }
      return fileType && fileLimit
    },

    /** 文件移除时 */
    handleRemove(file, fileList) {
      this.fileList = fileList
    },

    // 文件改变时
    fileChange(file, fileList) {
      this.fileList = fileList
      this.file = file
    },

    async uploadFile(file) {
      // this.formData.append('file', file.file)

      console.log(file.file)
      const formData = new FormData()
      formData.append('file', file.file)

      // debugger
      console.log('formData:', formData)

      const {
        data: { data },
      } = await importOrder(formData).setConfig({
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      console.log(data)
    },

    // 文件移除之前
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },

    async jumpImportOffline() {
      // order-offline/import
      // this.updateImportDialog = true
      this.$router.push('/order-offline/import')
    },

    async onUpdateImport() {
      console.log('fileList:', this.fileList)
      console.log('this.file:', this.file)

      const formData = new FormData()
      formData.append('file', this.file.raw)

      // debugger
      console.log('formData:', formData)

      const {
        data: { data },
      } = await importOrder(formData).setConfig({
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      console.log(data)
    },

    async expressOrderInfo(row) {
      console.log(row)

      const {
        data: { data },
      } = await expressOrder(row.order_id)

      const { express, order } = data

      this.expressList = express || []
      this.expressOrder = order || {}

      this.drawer = true
    },
  },
  created() {
    this.hasPermsEdit = can('order.offline.edit')
    this.hasPermsPrint = can('order.offline.printer')
    this.hasPermsRefuse = can('order.offline.refuse')
    this.hasPermOrderBuyOffline = can('order.offline.create')
    this.hasPermOrderBuyAllExport = can('order.offline.all.export')
    this.hasPermsExpress = can('order.offline.express')
    this.hasPermOrderBuyExport = can('order.offline.export')
    this.hasPermsManageDownload = can('manage.download')
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  font-size: 14px;

  &:last-child {
    margin-bottom: 0;
  }
}

.bg-el-row {
  border: 1px solid #d8d8d8;
}

.grid-content-col-title {
  min-height: 52px;
  line-height: 52px;
  padding: 0 10px;
  background-color: #f5f5f6;
  border-bottom: 1px solid #d8d8d8;
  color: #000;

  .action {
    text-align: right;
  }
}

.grid-content-col-body {
  min-height: 130px;
  color: #666;

  .grid-body-left {
    padding-bottom: 10px;

    ul {
      margin: 0;
      padding: 0;
      width: 100%;

      span {
        margin: 10px 0 0 10px;
        display: inline-block;
      }

      li {
        list-style: none;
        line-height: 26px;
        margin-left: 40px;

        span {
          margin-left: 10px;
        }
      }
    }
  }

  .grid-body-right {
    .grid-body-right-content {
      min-height: 52px;
      line-height: 52px;
      padding-left: 20px;

      .grid-right-top {
        padding-left: 20px;
      }

      .grid-right-top-fist {
        padding-left: 0;
      }

      .grid-right-top-last {
        border-right: 0;
      }
    }

    .grid-body-right-content-first {
      padding-left: 0;
    }

    .grid-body-right-content-last {
      border-bottom: 0;
    }
  }
}
</style>
